import { useSelector, useDispatch } from "react-redux";
import {
    selectBidPopupStatus,
    closeBidPopup,
    selectProjectPopupOpen,
    closeProjectPopup,
} from "@/nav/navSlice";

import Modal from "@mui/material/Modal";

import BidPopup from "@/bids/BidPopup";
import CreateProjectPopup from "@/project/CreateProjectPopup";
import ProjectAgentWorkshop from "@/ai/ProjectAgentWorkshop";
import AiChatPopup from "@/ai/AiChatPopup";
import WelcomeTour from "@/nav/WelcomeTour";

function Popups() {
    const dispatch = useDispatch();
    const bidPopupOpen = useSelector(selectBidPopupStatus);
    const projectPopupOpen = useSelector(selectProjectPopupOpen);

    return (
        <>
            <Modal
                sx={{ overflow: "auto" }}
                open={bidPopupOpen.open}
                onClose={() => dispatch(closeBidPopup())}
            >
                <>
                    <BidPopup />
                </>
            </Modal>

            <Modal
                open={projectPopupOpen}
                onClose={() => dispatch(closeProjectPopup())}
            >
                <>
                    <CreateProjectPopup />
                </>
            </Modal>

            <ProjectAgentWorkshop />

            <AiChatPopup />

            <WelcomeTour />
        </>
    );
}

export default Popups;
